<template>

  <a-modal
      :title="title"
      :visible="visible"
      :width="600"
      @ok="handleSubmit"
      @cancel="handleCancel">

    <a-form :form="form">

      <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="名称" v-decorator.trim="['name', validatorRules.name]"/>
      </a-form-item>

      <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入描述" v-decorator.trim="[ 'description']"/>
      </a-form-item>
    </a-form>
  </a-modal>


</template>

<script>

import pick from "lodash/pick";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "DptCreateModal",
  mixins: [HttpMixins],
  data() {
    return {
      title: '',
      visible: false,
      model: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
      },
      validatorRules: {
        name: {rules: [{required: true, message: '请输入名称!'}]}
      },
      url: {
        add: window._CONFIG['domainURL'] + "/dpt",
        edit: window._CONFIG['domainURL'] + "/dpt"
      }
    }
  },
  methods: {
    add() {
      this.visible = true;
      this.title = '新增';
      this.model = {};
      this.form.resetFields();
    },

    edit(record) {
      let that = this;
      this.add();
      that.title = '编辑';
      that.model = Object.assign({}, record);
      that.$nextTick(() => {
        that.form.setFieldsValue(pick(that.model, 'name', 'description'));
      });
    },
    handleSubmit() {

      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (that.title === '编辑') {
            values.id = that.model.id;
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.put(that.url.edit, values, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
          if (that.title === '新增') {
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.post(that.url.add, values, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
        }
      })
    },
    handleCancel() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>
